<template>
  <div class="relative flex flex-col w-[250px] md:w-[250px] xl:w-[348px] h-fit bg-complementary-900 rounded-md px-6 py-4 shadow-tooltip md:z-[200]">
    <div class="flex flex-row mb-[8px]">
      <span class="material-symbols-rounded text-complementary-300">live_help</span>
      <p class="text-lg font-bold mr-[7px] text-complementary-300 text-start">
        {{ tooltipHayadataTexts.title_bold + " " }}
        <span class="font-regular">
					{{ tooltipHayadataTexts.title_regular }}
				</span>
      </p>
    </div>
    <p class="text-white text-base font-regular text-right"> {{ tooltipHayadataTexts.description }} </p>
    <img
        :class="[
				(positionBottom ? 'hidden xl:flex xl:bottom-[-9px] xl:left-[39px]' : ''),
				(positionTop ? 'rotate-180 top-[-9px] left-[39px]' : ''),
			]"
        alt="polygon green"
        class="absolute w-[19px] h-[11px] m-auto"
        src="@/assets/icons/global/polygon-green.svg"
    />
  </div>
</template>

<script>
export default {
  name: "tooltip-hayadata",
  props: {
    positionBottom: {
      type: Boolean,
      default: false,
    },
    positionLeft: {
      type: Boolean,
      default: false,
    },
    positionRight: {
      type: Boolean,
      default: false,
    },
    positionTop: {
      type: Boolean,
      default: false,
    },
    tooltipHayadataTexts: {
      type: Object,
      default: {
        // title_bold: " טוב לדעת! ",
        title_bold: "למה חסר מוצרים?",
        description: "לא נחמד להתקע עם חוסרים. אז למה זה קורה? בגלל שאנחנו מתנהלים ישירות מול הספקים ומנהלים מלאי שבועי כדי שתקבלו את המחיר הכי נמוך בלי עלויות אחסנה מיותרות. ולפעמים, ממש כמוכם, אנחנו נתקעים עם חוסר בגלל ספק שהתאדה או לא עמד בהתחייבות. מה שבטוח, שלא תחויבו על אף מוצר שלא הגיע."
      }
    }
  }
}
</script>

<style>

</style>